import { ReactNode } from 'react';
import cn from '../../../../utils/classnames';
import { useModalContext } from '../../hooks/use-modal-context';

type ModalHeaderProps = {
    closeButton?: boolean;
    className?: string;
    children?: ReactNode;
};

const ModalHeader = (props: ModalHeaderProps) => {
    const { closeButton = true, className, children } = props;

    const { onHide } = useModalContext();

    return (
        <div className={cn('modal-header', className)}>
            {children}
            {closeButton && <button className='btn-close' type='button' onClick={onHide} aria-label='Close' />}
        </div>
    );
};

export default ModalHeader;
